import { Component, Input } from '@angular/core';

@Component({
    selector: 'gbc-info-container',
    templateUrl: './info-container.component.html',
    styleUrls: ['./info-container.component.scss'],
    standalone: true
})
export class InfoContainerComponent {
  @Input() public header: string;

}
